import { fetchUserAttributes, getCurrentUser } from "aws-amplify/auth";
import {
  listMyTournamentParticipants,
  listOwnedBullseyeMatches,
  listOwnedMatches,
  listOwnedUSPSAMatches,
  listTournamentsPage,
} from "./leaderboardApi";

export async function loadCompetitionDirectorSignal() {
  const user = await getCurrentUser();
  const attrs = await fetchUserAttributes();
  const userId = String(attrs?.sub || user?.userId || "").trim();
  if (!userId) return "none";

  const [
    arcMatches,
    bullseyeMatches,
    uspsaMatches,
    ownedTournaments,
    approvedOrganizerRows,
  ] = await Promise.allSettled([
    listOwnedMatches(userId, { limit: 1 }),
    listOwnedBullseyeMatches(userId, { limit: 1 }),
    listOwnedUSPSAMatches(userId, { limit: 1 }),
    listTournamentsPage({ owned: true, visibility: null, limit: 1 }),
    listMyTournamentParticipants({ status: "approved" }),
  ]);

  const hasRows = (result) => {
    if (result.status !== "fulfilled") return false;
    const rows = Array.isArray(result.value?.data) ? result.value.data : result.value;
    return Array.isArray(rows) && rows.length > 0;
  };
  const hasVerificationFailure = [
    arcMatches,
    bullseyeMatches,
    uspsaMatches,
    ownedTournaments,
    approvedOrganizerRows,
  ].some((result) => result.status === "rejected");

  if (hasRows(arcMatches) || hasRows(bullseyeMatches) || hasRows(uspsaMatches)) {
    return "match";
  }
  if (hasRows(ownedTournaments)) {
    return "tournament";
  }
  if (hasRows(approvedOrganizerRows)) {
    return "organizer";
  }
  if (hasVerificationFailure) {
    return "unknown";
  }
  return "none";
}

export function directorModeLabel(signal) {
  return signal === "none" ? "Run a Match" : "Director Console";
}

export function directorModePath(signal) {
  if (signal === "none") {
    return "/matches/manage/new";
  }
  return signal === "tournament" || signal === "organizer" ? "/matches/manage/tournaments" : "/matches/manage";
}
